import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!

  return (_openBlock(), _createBlock(_component_button_dropdown, {
    class: "ButtonDropdown--right",
    icon: "fas fa-ellipsis-h"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_button, {
        class: "small primary",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.emitPayment(1)), ["stop"])),
        disabled: _ctx.row.hasRoadCourierPayment
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Добавить Платный проезд ")
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_the_button, {
        class: "small primary",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.emitPayment(2)), ["stop"])),
        disabled: _ctx.row.hasParkingCourierPayment
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Добавить Платную парковку ")
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_the_button, {
        class: "small primary",
        onClick: _withModifiers(_ctx.emitWaitList, ["stop"])
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Добавить в ЛО ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }))
}